import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Modal,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableBody,
} from "@mui/material";
import { ModalBaseStyles, ModalHeader } from "../../Common/styles/modal";
import http from "../../../utils/http";
import { errorToastMessage } from "../../../utils/toast";
import {
  NoDataContainer,
  StyledTableCell,
  TableBorderRadiusTopLeftRight,
} from "../../Common/styles/table";
import { AxiosResponse } from "axios";
import StatusBadge from "../../Common/UI/StatusTag";

const statusMap: any = {
  live: { label: "Live", variant: "active" },
  not_live: { label: "Not Live", variant: "cancelled" },
  closed: { label: "Closed", variant: "completed" },
};

interface TagDetailsModalProps {
  open: boolean;
  onClose: () => void;
  data: any;
}

const ViewParticipantStudiesModal: React.FC<TagDetailsModalProps> = ({
  open,
  onClose,
  data,
}) => {
  const [loading, setLoading] = useState(true);
  const [studies, setStudies] = useState<any[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let res: AxiosResponse;
        res = await http.get(
          `/admin/registry/participants/${data?.id}/studies`
        );
        const resData = res.data?.data;
        const newData = resData?.map((study: any) => ({
          id: study?.id,
          name: study?.name,
          status: study?.status,
        }));
        setStudies(newData);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        errorToastMessage(error as Error);
      }
    };
    fetchData();
  }, [data?.id]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ ...ModalBaseStyles, minHeight: "20vh" }}>
        <ModalHeader title={"Studies"} onCloseClick={onClose} />
        {!loading && studies?.length > 0 && (
          <Box
            sx={{
              maxHeight: "calc(100vh - 295px)",
              overflow: "auto",
              mb: 2,
            }}
          >
            <Table sx={TableBorderRadiusTopLeftRight}>
              <TableHead>
                <TableRow>
                  <StyledTableCell>Study Name</StyledTableCell>
                  <StyledTableCell>Status</StyledTableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {studies?.map((row: any) => (
                  <TableRow key={row?.id}>
                    <StyledTableCell>{row?.name}</StyledTableCell>
                    <StyledTableCell>
                      <StatusBadge
                        label={statusMap[row?.status]?.label ?? row?.status}
                        variant={statusMap[row?.status]?.variant}
                      />
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
        {loading && (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
            <CircularProgress size={25} />
          </Box>
        )}
        {!loading && studies?.length === 0 && (
          <NoDataContainer>
            <Typography variant="body1" color="gray">
              No Data
            </Typography>
          </NoDataContainer>
        )}
      </Box>
    </Modal>
  );
};

export default ViewParticipantStudiesModal;
